// extracted by mini-css-extract-plugin
export default {"pcBottom":"footer_pcBottom__wxuQg","copyRight":"footer_copyRight__RcxkR","footer":"footer_footer__BCx8i","ga":"footer_ga__7m7LP"};